export default {
  docApi: {
    doc: {
      getListByPage: 'api/dify/doc/getListByPage',
      docs: 'api/dify/doc/docs'
    }
  }
}
